/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { PrimaryDrawer } from "../../../../../Shared/components/Drawer/PrimaryDrawer";
import { Space, Row, Col, Image } from "antd";
import { Button, FormControl, RadioGroup, FormControlLabel, Radio, TextField } from "@mui/material";
import crudActions from "../../../../../CRUD/redux/actions";
import { NavLink } from "react-router-dom";
import GridViewNew from "./GridViewNew";
import { useSelector } from "react-redux";
import { SelectedIcon, UnSelectedIcon } from "../../../../../Shared/components/Icons/selectedIcon";
import SearchIcon from "../../../../../../assets/images/icon_actions/Search Icon.svg";
import { storageSetItem, checkProductSearch, checkBillProductView, idNamingConversion, getBusinessId } from "../../../../../../helpers/utilities";
import { toast } from 'react-toastify';
import { BillLineForm } from "./BillLineForm";
import { emptyValidation, customNumberValidation, customNumberValidationQuantity } from "../../../../../../helpers/validation";
import unitActions from "../../../../../Product/Setup/redux/actions";
import ClearIcon from "../../../../../../assets/images/icon_actions/Clear Icon.svg";
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { getRequest } from '../../../../../../helpers/axiosClient';
import usePrevious from "../../../../../Shared/components/Previous";


export const CustomerProducts = (props) => {
    const { visible, handleClose, clsx, classes, dispatch, form, unitMesurementdetails, locationApi,
        lineSubmit, customObject, locationDetails, productApi } = props;
    const [skip, setSkip] = useState(0);
    const limit = 100;
    const [selected, setSelected] = useState([]);
    const [type, setType] = useState(form?.serviceType === 'JOBWORK' ? 'myProducts' : 'customerProducts');
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const { productGroupDetails } = useSelector(state => state.productSetupReducer);
    const [productId] = useState('');
    const [productGroupId, setProductGroupId] = useState('');
    const [changeSelected, setChangeSelected] = useState(false);
    const [customerProducts, setCustomerProducts] = useState(false);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { parameterDetails } = useSelector(state => state.homeReducer);
    const [lineForm, setLineForm] = useState({});
    const [lineError, setLineError] = useState({});
    const [searchOrder, setSearchOrder] = useState({ type: 'quote' });
    const [errorLineForm, setErrorLineForm] = useState({});
    const [showNameDesc, setShowNameDesc] = useState(checkBillProductView());
    const [units, setUnits] = useState([]);
    const [formVisible, setFormVisible] = useState(false);
    const [orderDetails, setOrderDetails] = useState([]);
    const [orderLineDetails, setOrderLineDetails] = useState([]);

    useEffect(() => {
        if (visible) {
            dispatchFilter(type);
            locationApi();
            dispatch({
                type: unitActions.PRODUCT_GROUP_DETAILS_START, url: 'product-groups', filter: {
                    order: 'id desc'
                }
            });
            if (form?.serviceType === 'SERVICE BILL' || form?.serviceType === 'JOB WORK') {
                dispatchSalesOrder();
            }
        }
    }, [visible]);

    useEffect(() => {
        if (selected && selected?.length > 0) {
            const newTodos = selected.map((el) => {
                return calculateLineTotal(el);
            });
            setSelected(newTodos);
            setLineForm(calculateLineTotal(lineForm));
        }
    }, [changeSelected]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }

        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {

                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    useEffect(() => {
        if (loadMore && getList.length === 0 && type === 'customerProducts') {
            setCustomerProducts(true);
            handleTypeChange('myProducts');
        }
    }, [getList, loadMore]);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 0 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(type, productGroupId);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(type, productGroupId);
                }, 500);
            }
        }
    }, [search]);

    const handleDisplayChange = (val) => {
        storageSetItem('billProductView', val);
        setShowNameDesc(val);
    }

    const dispatchFilter = (type, productGroupId = '', skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }


        let filter = { ["and"]: [{ status: 'ACTIVE' }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'SALES' } }] }] };
        if (productApi === 'all') {
            filter = { ["and"]: [{ status: 'ACTIVE' }] };
        }
        if (productGroupId) {
            filter['and'].push({ productGroupId: productGroupId });
        }

        let or = { ["or"]: [] };
        let array = ['productName', 'productId', 'description', 'type', 'barcode', 'code'];
        if (search !== '') {
            if (checkProductSearch() === 'both') {
                array = ['productName', 'code'];
            } else if (checkProductSearch() === 'name') {
                array = ['productName'];
            } else if (checkProductSearch() === 'code') {
                array = ['code'];
            } else if (checkProductSearch() === 'mrp') {
                array = ['mrp'];
            }
            array.map((el) => {
                if (el === 'code' || el === 'mrp') {
                    return or['or'].push({ [el]: search.trim() })
                } else {
                    return or['or'].push({ [el]: { like: '%' + search.trim() + '%' } })
                }
            });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: type === 'customerProducts' ? `v1/schedules/customer-products` : `client-products`,
            skip: skip,
            filter: {
                where: type === 'customerProducts' ? { 'customerId': form?.customerId, status: 'ACTIVE' } : filter,
                order: 'id desc',
                limit: limit,
                skip: skip,
            }
        });
    }

    const dispatchSalesOrder = async (type = searchOrder?.type) => {
        try {
            let filter = { ["and"]: [] };

            if (search) {
                filter["and"].push({ serialNo: search });
            }

            if (form?.serviceType === "SERVICE BILL") {
                filter["and"].push({ customerId: form?.customerId });
                if (type === 'quote') {
                    filter["and"].push({ QuoteStatus: { neq: 'CREATED' } });
                } else {
                    filter["and"].push({ OrderStatus: { neq: 'CREATED' } });
                }
            } else if (form?.serviceType === "JOB WORK") {
                filter["and"].push({ supplierId: form?.supplierId });
                filter["and"].push({ OrderStatus: { neq: 'CREATED' } });
            }
            filter = {
                where: filter
            };

            const baseUrl = form?.serviceType === "SERVICE BILL" ? `${type === 'quote' ? 'sales-quotes' : 'v1/sales-order/sales-orders'}` : "v1/sales-order/purchase-orders";

            const url = `${baseUrl}?filter=${encodeURIComponent(
                JSON.stringify(filter)
            )}`;
            const response = await getRequest(url);
            setOrderDetails(response.data);
        } catch (error) {
            setOrderDetails([]);
        }
    };

    const dispatchSalesOrderLines = async (search = '', id) => {
        try {
            let filter = { ["and"]: [{ salesOrderId: id }] };

            if (form?.serviceType === "JOB WORK") {
                filter = { ["and"]: [{ purchaseOrderId: id }] };
            }

            if (searchOrder?.type === 'quote') {
                filter = { ["and"]: [{ salesQuoteId: id }] };
            }

            if (search) {
                filter["and"].push({ serialNo: search });
            }

            filter = {
                where: filter
            };
            const baseUrl =
                form?.serviceType === "SERVICE BILL" ? `${searchOrder?.type === 'quote' ? 'sales-quote-line-items' : 'v1/sales-order/sales-order-line-items'}` : "v1/sales-order/purchase-order-line-items";

            const url = `${baseUrl}?filter=${encodeURIComponent(
                JSON.stringify(filter)
            )}`;


            const response = await getRequest(url);

            setOrderLineDetails(response.data);
        } catch (error) {
            setOrderDetails([]);
        }
    };

    // const handleLineSubmit = () => {
    //     if (!checkLineForm(lineForm)) {
    //         toast.dismiss();
    //         toast.error('Please select value in the highlighted mandatory field');
    //         return false;
    //     }

    //     let a = [];
    //     selected && selected?.length > 0 && selected?.map((element, i) => {
    //         return a.push({ ...element })
    //     });


    //     a && a.length > 0 && a.map((element, i) => {
    //         delete element.discountCalcAmount; delete element.useMrp; delete element.productUnitId;
    //         delete element.discountPercAmount; delete element.location; delete element.costPrice;
    //         if (searchOrder?.id) {
    //             element.orderId = searchOrder.id;
    //         }
    //         if (searchOrder?.lineId) {
    //             element.orderLineId = searchOrder.lineId;
    //         }
    //         if (element?.batchDetails?.length > 0) {
    //             let aL = [];
    //             element?.batchDetails?.forEach((element) => {
    //                 if (element?.batchNumber !== '') {
    //                     let amount = parseFloat(parseFloat(element?.purchaseQuantity || 0) * parseFloat(lineForm?.pricePerUnit || 0));
    //                     element.perUnitPrice = lineForm?.pricePerUnit || 0;
    //                     element.purchaseQuantity = parseFloat(element?.purchaseQuantity || 0);
    //                     element.mrp = parseFloat(element?.mrp || 0);;
    //                     element.unitId = lineForm?.unitId;
    //                     element.purchasePrice = amount - parseFloat(element?.discountAmount || 0);
    //                     element.businessId = getBusinessId();
    //                     if (lineForm?.productId) element.productId = lineForm?.productId;
    //                     aL.push(element);
    //                 }
    //             });
    //             element.batchDetails = aL;
    //         }
    //         return a.splice(i, 1, element);
    //     });

    //     lineSubmit(a);
    // }

    const handleLineSubmit = () => {
        if (!checkLineForm(lineForm)) {
            toast.dismiss();
            toast.error('Please select value in the highlighted mandatory field');
            return false;
        }

        let a = selected?.map((element) => {
            let updated = { ...element };
            delete updated.discountCalcAmount;
            delete updated.useMrp;
            delete updated.productUnitId;
            delete updated.discountPercAmount;
            delete updated.costPrice;

            if (searchOrder?.id) updated.orderId = searchOrder.id;
            if (searchOrder?.lineId) updated.orderLineId = searchOrder.lineId;
            if (searchOrder?.type) updated.orderType = searchOrder?.type;
            if (searchOrder?.orderDetails) updated.orderDetails = searchOrder.orderDetails;
            if (searchOrder?.orderLineDetails) updated.orderLineDetails = searchOrder.orderLineDetails;

            if (updated?.batchDetails?.length > 0) {
                updated.batchDetails = updated.batchDetails
                    .filter(batch => batch?.batchNumber)
                    .map(batch => {
                        const purchaseQuantity = parseFloat(batch.purchaseQuantity) || 0;
                        const perUnitPrice = parseFloat(lineForm.pricePerUnit) || 0;
                        const discountAmount = parseFloat(batch.discountAmount) || 0;
                        const purchasePrice = (purchaseQuantity * perUnitPrice) - discountAmount;
                        return {
                            ...batch, perUnitPrice, purchaseQuantity, mrp: parseFloat(batch.mrp) || 0, unitId: lineForm.unitId, purchasePrice, businessId: getBusinessId(), productId: element.productId
                        };
                    });
            }

            return updated;
        }) || [];

        lineSubmit(a);
    };


    const onDeleteBatch = (data, details) => {
        // 2️⃣ Update the selected list
        const newTodos = selected.map(el => {
            if (el.productId === data.productId) {
                const updatedBatchDetails = (Array.isArray(el.batchDetails) ? el.batchDetails : [])
                    .filter(batch => batch.batchNumber !== details.batchNumber);

                // Update the line form and product entry
                if (el.productId === data.productId) {
                    setLineForm({
                        ...data,
                        batchDetails: updatedBatchDetails.length > 0 ? updatedBatchDetails : [],
                    });
                }

                return {
                    ...el,
                    batchDetails: updatedBatchDetails.length > 0 ? updatedBatchDetails : [],
                };
            }
            return el;
        });

        setSelected(newTodos);
        setChangeSelected(prev => !prev);
    };



    const calculateLineTotal = (el) => {
        let result = { ...el, amount: el.quantity * el.pricePerUnit };
        return result;
    }

    // const handleUnits = (data) => {
    //     let filter = {
    //         where: {
    //             and: [{ productId: data?.id }, { or: [{ unitId: data?.salesUnitId }, { toUnitId: data?.salesUnitId },] }]
    //         }
    //     }; let uFilter = {
    //         where: {
    //             or: [{ unitId: data?.salesUnitId }, { toUnitId: data?.salesUnitId }]
    //         }
    //     };
    //     let a = [data?.salesUnitId, data?.skuUnitId];

    //     getRequest(`${process.env.REACT_APP_API_URL}/product-unit-conversions/?filter=${encodeURIComponent(JSON.stringify(filter))}`)
    //         .then(response => {
    //             let data = response.data;
    //             if (data && data.length > 0) {
    //                 data.forEach(el => {
    //                     a.push(el.unitId)
    //                     a.push(el.toUnitId);
    //                 });
    //             }
    //             return getRequest(`${process.env.REACT_APP_API_URL}/unit-conversions/?filter=${encodeURIComponent(JSON.stringify(uFilter))}`);
    //         }).then(uResponse => {
    //             let uData = uResponse.data;
    //             if (uData && uData.length > 0) {
    //                 uData.forEach(el => {
    //                     a.push(el.unitId)
    //                     a.push(el.toUnitId)
    //                 });
    //             }

    //             const filtered = unitMesurementdetails.filter(el => a.includes(el.id));
    //             setUnits(prev => {
    //                 // const current = prev[data?.id] || [];  // Get existing array or empty array
    //                 return {
    //                     ...prev,
    //                     [data?.id]: [...filtered]  // Append `filtered` array
    //                 };
    //             });
    //             return filtered;
    //         })
    //         .catch(error => {
    //             console.error("Error fetching data", error);
    //         });
    // }

    const handleUnits = async (data) => {
        let filter = {
            where: {
                and: [{ productId: data?.id }, { or: [{ unitId: data?.salesUnitId }, { toUnitId: data?.salesUnitId },] }]
            }
        }; let uFilter = {
            where: {
                or: [{ unitId: data?.salesUnitId }, { toUnitId: data?.salesUnitId }]
            }
        };
        let a = [data?.salesUnitId, data?.skuUnitId];

        // 🔥 await first API
        const response = await getRequest(`${process.env.REACT_APP_API_URL}/product-unit-conversions/?filter=${encodeURIComponent(JSON.stringify(filter),)}`,);

        if (response?.data?.length) {
            response.data.forEach(el => {
                a.push(el.unitId);
                a.push(el.toUnitId);
            });
        }

        // 🔥 await second API
        const uResponse = await getRequest(
            `${process.env.REACT_APP_API_URL}/unit-conversions/?filter=${encodeURIComponent(
                JSON.stringify(uFilter),
            )}`,
        );

        if (uResponse?.data?.length) {
            uResponse.data.forEach(el => {
                a.push(el.unitId);
                a.push(el.toUnitId);
            });
        }

        const filtered = unitMesurementdetails.filter(el => a.includes(el.id));

        // keep state update if you need it
        setUnits(prev => ({
            ...prev,
            [data?.id]: filtered,
        }));
        return filtered;
    };

    const checkLineForm = (lineForm) => {
        let emptyUnit = emptyValidation('Unit', lineForm?.unitId, 'dropDown');
        let emptyPrice = customNumberValidation('Price', lineForm?.pricePerUnit);
        let emptyQuantity = customNumberValidationQuantity('Quantity', lineForm?.quantity);
        let emptyAmount = emptyValidation('Line Amount', lineForm?.amount);
        let ret = false;

        let batchQuantityError = { isValid: true, errors: '' };
        console.log(!lineForm?.batchDetails);
        if (lineForm?.batchOverride && !lineForm?.batchDetails) {
            batchQuantityError = { isValid: false, errors: "Please enter Batch Details" }
        }

        if (lineForm?.batchDetails && lineForm?.batchDetails?.length > 0) {
            let batchQuantity = lineForm?.batchDetails?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.purchaseQuantity || 0)), 0);

            //let batchQuantity = batch?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.purchaseQuantity || 0)), 0);
            if (batchQuantity !== parseFloat(lineForm?.quantity)) {
                batchQuantityError = { isValid: false, errors: 'Total Batch quantity should equal Line Quantity' }
            }

            const emptyBatchNumbers = lineForm?.batchDetails?.filter(item => !item.batchNumber);
            if (emptyBatchNumbers?.length) {
                batchQuantityError = { isValid: false, errors: "Batch Number Can't be blank" }
            }
        }

        setLineError({});
        if (emptyUnit.isValid && batchQuantityError.isValid &&
            emptyPrice.isValid && emptyQuantity.isValid && emptyAmount.isValid
        ) {
            ret = true;
            setErrorLineForm({});
        } else {
            setLineError({
                unitId: emptyUnit?.errors || false,
                pricePerUnit: emptyPrice?.errors || false,
                quantity: emptyQuantity?.errors || false,
                batchQuantity: batchQuantityError?.errors || false
            });
            setErrorLineForm(lineForm);
            ret = false;
        }

        return ret
    }

    const handleQuantityChange = (data, v) => {
        let newTodos = [];

        if (lineForm?.productId && !checkLineForm(lineForm)) {
            toast.dismiss();
            toast.error('Please select value in the highlighted mandatory field');
            return false;
        }

        if (v === 'decrease') {
            newTodos = selected.map((el) => {
                if (el.productId === data.productId) {
                    setLineForm({ ...el, 'quantity': parseInt(el.quantity) - parseInt(1) });
                    return { ...el, 'quantity': parseInt(el.quantity) - parseInt(1) };
                }
                return el;
            });
        } else {
            newTodos = selected.map((el) => {
                if (el.productId === data.productId) {
                    setLineForm({ ...el, 'quantity': parseInt(el.quantity) + parseInt(1) });
                    return { ...el, 'quantity': parseInt(el.quantity) + parseInt(1) };
                }
                return el;
            });
        }
        setSelected(newTodos);
        setChangeSelected(!changeSelected);
    }

    const handleGroupChange = (v) => {
        setProductGroupId(v);
        dispatchFilter(type, v);
    }

    const changeHandlerLine = async (data, e, name = '', relation = '') => {
        let newTodos = [];
        for (const el of selected) {
            if (el.productId === data.productId) {
                if (relation) {
                    const updatedLine = { ...data, [name]: e.id, [relation]: e };
                    setLineForm(updatedLine);
                    newTodos.push({ ...el, [name]: e.id, [relation]: e });
                } else {
                    if (name === 'pricePerUnit') {
                        if (lineForm?.unitId === lineForm?.productUnitId) {
                            if (lineForm?.useMrp && lineForm?.maxRetailPrice !== '' && parseFloat(lineForm?.maxRetailPrice) < parseFloat(e)) {
                                toast.dismiss();
                                toast.warning('Unit price is greater than MRP Price');
                            }
                        }
                    }
                    const updatedLine = { ...data, [name]: e };
                    setLineForm(updatedLine);
                    newTodos.push({ ...el, [name]: e });
                }
            } else {
                newTodos.push(el);
            }
        }
        setSelected(newTodos);
        setChangeSelected(!changeSelected);
    };

    const addBatch = (data) => {
        let newTodos = [];
        for (const el of selected) {
            if (el.productId === data.productId) {
                setLineForm({
                    ...data,
                    batchDetails: [
                        ...(Array.isArray(data.batchDetails) ? data.batchDetails : []),
                        { batchNumber: '', purchaseQuantity: 1 },
                    ],
                });
                newTodos.push({
                    ...data,
                    batchDetails: [
                        ...(Array.isArray(data.batchDetails) ? data.batchDetails : []),
                        { batchNumber: '', purchaseQuantity: 1 },
                    ],
                });
            } else {
                newTodos.push(el);
            }
        }
        setSelected(newTodos);
        setChangeSelected((prev) => !prev);
    }

    const changeHandlerBatch = (data, e, name, i) => {
        const updatedArr = [...(Array.isArray(data.batchDetails) ? data.batchDetails : [])];
        updatedArr[i] = {
            ...updatedArr[i],
            [name]: e,
        };

        let newTodos = [];
        for (const el of selected) {
            if (el.productId === data.productId) {
                setLineForm({
                    ...data,
                    batchDetails: updatedArr,
                });
                newTodos.push({
                    ...data,
                    batchDetails: updatedArr,
                });
            } else {
                newTodos.push(el);
            }
        }
        setSelected(newTodos);
        setChangeSelected((prev) => !prev);
    };


    const handleClick = async (data, dataPro) => {
        if (lineForm && lineForm?.productId === data?.id) {
            let selectedSIngleIndex = selected?.findIndex(el => el.productId === lineForm.productId);
            if (selectedSIngleIndex >= 0) {
                setErrorLineForm({});
                setSelected(prevState => {
                    setLineForm(prevState.filter((value, i) => i !== selectedSIngleIndex)[prevState.filter((value, i) => i !== selectedSIngleIndex).length - 1]);
                    return prevState.filter((value, i) => i !== selectedSIngleIndex)
                });
                setLineError({});
            }
            return false;
        }

        if (lineForm?.productId && !checkLineForm(lineForm)) {
            toast.dismiss();
            toast.error('Please select value in the highlighted mandatory field');
            return false;
        }

        let selectedIndex = selected?.findIndex(el => el.productId === data.id);
        if (selectedIndex >= 0) {
            setSelected(prevState => {
                setLineForm(prevState.filter((value, i) => i !== selectedIndex)[prevState.filter((value, i) => i !== selectedIndex).length - 1]);
                return prevState.filter((value, i) => i !== selectedIndex)
            });
        } else {
            let d = {
                'productId': data?.id,
                'product': data,
                'quantity': parseFloat(form?.serviceType === 'SERVICE BILL' ? `-${dataPro?.quantity || 1}` : `${dataPro?.quantity || 1}`),
                'unitId': data.salesUnitId,
                'productUnitId': data.salesUnitId,
                'unit': data?.salesUnit,
                'mrp': parameterDetails?.productUnitPrice ? data?.mrp : 0,
                'pricePerUnit': parameterDetails?.productUnitPrice ? (data?.costPrice || 0) : 0,
                'amount': 0,
                'costPrice': data?.costPrice || '',
                'batchOverride': data?.batchActivation || false
            };

            if (parameterDetails?.inventoryTransaction) {
                let units = await handleUnits(data);
                if (units.find(el => el.id === form?.unitId)) {
                    d.unit = form?.unit;
                    d.unitId = form?.unitId;
                }
                console.log(form);
            }

            if (locationDetails && locationDetails?.length > 0) {
                let a = locationDetails?.filter(el => el.default);
                if (a?.length) {
                    d.locationId = a[0]?.id;
                    d.location = a[0];
                } else {
                    d.locationId = locationDetails[0]?.id;
                    d.location = locationDetails[0];
                }
            }

            setLineForm(calculateLineTotal(d));
            setSelected((prevState) => {
                return [...prevState, calculateLineTotal(d)];
            });
        }
    };

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(type, productGroupId, s);
    }

    const handleTypeChange = (value) => {
        setType(value);
        dispatchFilter(value, productGroupId);
    }

    const changeSearchType = (value) => {
        storageSetItem('productSearch', value);
        dispatchFilter(type, productGroupId);
    }

    const handleLineForm = (type, val) => {
        const index = selected.findIndex((a) => a.productId === val);
        if (index >= 0) {
            if (type === 'prev') {
                setLineForm(selected[index - 1]);
                //  let d = selected[index - 1];

            } else {
                setLineForm(selected[index + 1]);
                // let d = selected[index + 1];

            }
        }
    }

    return (
        <PrimaryDrawer
            anchor={'right'}
            open={visible}
            variant={'temporary'}
            handleClose={() => handleClose()}
            width={(selected.length ? '1000px' : '650px')}
            title={'Add Sales Lines'}
            className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
            component={
                <div className={clsx(classes.customForm, classes.customFormProducts, classes.removeUnderline)}>
                    <div className={clsx(classes.customFormLeft, { [classes.customFormLeftSel]: selected.length > 0 })}>
                        <div className={clsx(classes.customFormFlex, classes.customFormFlexProducts, { [classes.customFormFlexGrid]: selected.length > 0 })}>
                            {console.log(searchOrder)}
                            {
                                form?.enableServices &&
                                <Row gutter={30} style={{ marginBottom: 10 }}>
                                    {
                                        form?.serviceType === 'SERVICE BILL' && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <FormControl
                                                style={{ marginBottom: 10 }}
                                                className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                                                variant={'standard'}
                                                fullWidth>
                                                <RadioGroup
                                                    row
                                                    value={searchOrder.type}
                                                    onChange={(e) => {
                                                        setSearchOrder({
                                                            type: e.target.value
                                                        }); dispatchSalesOrder(e.target.value)
                                                    }}>
                                                    {
                                                        <FormControlLabel value="quote" control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="Quote" />
                                                    }
                                                    <FormControlLabel value="order" control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="Order" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Col>
                                    }
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                        <AutoCompleteComponent
                                            customLabel={form?.serviceType === 'SERVICE BILL' ? `${searchOrder?.type === 'quote' ? 'Sales Quote' : 'Sales Order'}` : "Purchase Order"}
                                            heads={[{ 'key': 'serialNo', 'name': 'ID' }]}
                                            details={orderDetails}
                                            parentValue={customObject(orderDetails, searchOrder.id)}
                                            position={"bottom"}
                                            variant={'outlined'}
                                            searchType={(s) => dispatchSalesOrder(s)}
                                            onChange={(data) => {
                                                setSearchOrder({
                                                    type: searchOrder.type,
                                                    id: data.id,
                                                    orderDetails: data
                                                });
                                                dispatchSalesOrderLines('', data.id)
                                            }}
                                        />
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                        <AutoCompleteComponent
                                            customLabel={form?.serviceType === 'SERVICE BILL' ? `${searchOrder?.type === 'quote' ? 'Sales Quote Lines' : 'Sales Order Lines'}` : "Purchase Order Lines"}
                                            heads={[{ 'key': 'lineNumber', 'name': 'Line Number' }, { 'key': 'description', 'name': 'Description' }, { 'key': 'amount', 'name': 'Amount' }]}
                                            details={orderLineDetails}
                                            parentValue={customObject(orderLineDetails, searchOrder.lineId)}
                                            position={"bottom"}
                                            variant={'outlined'}
                                            searchType={(s) => dispatchSalesOrderLines(s, searchOrder.id)}
                                            onChange={(data) => setSearchOrder({
                                                ...searchOrder,
                                                lineId: data.id,
                                                orderLineDetails: data
                                            })}
                                        />
                                    </Col>
                                </Row>
                            }
                            {
                                type === 'myProducts' && <Row>
                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <div style={{ marginBottom: 10 }} className={clsx(classes.dropDownWithSearch, classes.customerLabelNone)}>
                                            <AutoCompleteComponent
                                                customLabel={"Type"}
                                                heads={[{ 'key': 'label', 'name': 'Search Configuration' }]}
                                                details={[{ id: 'name', label: "Name" }, { id: 'code', label: "Code" }, { id: 'both', label: "Both" }, { id: 'standard', label: "Standard" }, { id: 'mrp', label: "MRP" }]}
                                                parentValue={customObject([{ id: 'name', label: "Name" }, { id: 'code', label: "Code" }, { id: 'both', label: "Both" }, { id: 'standard', label: "Standard" }, { id: 'mrp', label: "MRP" }], checkProductSearch())}
                                                position={"bottom"}
                                                variant={'outlined'}
                                                onChange={(data) => changeSearchType(data.id)}
                                            />
                                            <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                                <TextField autoComplete='one-time-code'
                                                    placeholder={
                                                        checkProductSearch() === 'standard' ? 'Search Name, ID, Bar Code, and Code' :
                                                            checkProductSearch() === 'both' ? 'Search Name, and Code' :
                                                                checkProductSearch() === 'name' ? 'Search Name' :
                                                                    checkProductSearch() === 'code' ? 'Search Code' :
                                                                        checkProductSearch() === 'mrp' ? 'Search MRP' : ''
                                                    }
                                                    value={search}
                                                    type='search'
                                                    variant={'standard'}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                    fullWidth
                                                    onFocus={() => setIconAnimation(true)}
                                                    onBlur={() => setIconAnimation(false)}
                                                />
                                                <Image src={SearchIcon} preview={false} />
                                                {
                                                    search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                        <Image
                                                            src={ClearIcon}
                                                            preview={false}
                                                        />
                                                    </NavLink>
                                                }
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            }
                            <Row style={{ height: type !== 'myProducts' ? "100%" : "calc(100% - 45px)" }}>
                                <Col span={16} className={clsx(classes.prod_group)} style={{ height: "calc(100% - 32px)" }}>
                                    <FormControl
                                        style={{ marginBottom: 10 }}
                                        className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                                        variant={'standard'}
                                        fullWidth>
                                        <RadioGroup
                                            row
                                            value={type}
                                            onChange={(e) => handleTypeChange(e.target.value)}>
                                            {
                                                form?.serviceType === 'JOBWORK' ? '' : <FormControlLabel value="customerProducts" disabled={customerProducts} control={<Radio
                                                    checkedIcon={<UnSelectedIcon />}
                                                    icon={<SelectedIcon />}
                                                />} label="Customer Products" />
                                            }
                                            <FormControlLabel value="myProducts" control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="My Products" />
                                        </RadioGroup>
                                    </FormControl>

                                    {/* <GridView
                                        {...props}
                                        type={type}
                                        loadTasks={() => dispatchFilter(type)}
                                        details={getList}
                                        loadMore={loadMore}
                                        salesType={creditNote ? 'Sale Return' : 'Sales'}
                                        loadMoreContent={loadMoreContent}
                                        loadMoreTask={() => loadMoreTask()}
                                        classes={classes}
                                        clsx={clsx}
                                        selected={selected}
                                        productId={productId}
                                        errorLineForm={errorLineForm}
                                        handleQuantityChange={(data, v) => handleQuantityChange(data, v)}
                                        changeHandlerLine={(data, e, name = '', relation = '') => changeHandlerLine(data, e, name, relation)}
                                        handleGridClick={(data, dataPro) => handleClick(data, dataPro)}
                                        visible={formVisible}
                                        handleClose={(v) => setFormVisible(v)}
                                        lineError={lineError}
                                        form={lineForm}
                                    /> */}
                                    <GridViewNew
                                        {...props}
                                        type={type}
                                        loadTasks={() => dispatchFilter(type)}
                                        details={getList}
                                        loadMore={loadMore}
                                        salesType={form?.serviceType === 'SERVICE BILL' ? 'Sale Return' : 'Sales'}
                                        loadMoreContent={loadMoreContent}
                                        loadMoreTask={() => loadMoreTask()}
                                        classes={classes}
                                        clsx={clsx}
                                        selected={selected}
                                        productId={productId}
                                        errorLineForm={errorLineForm}
                                        handleQuantityChange={(data, v) => handleQuantityChange(data, v)}
                                        changeHandlerLine={(data, e, name = '', relation = '') => changeHandlerLine(data, e, name, relation)}
                                        handleGridClick={(data, dataPro) => handleClick(data, dataPro)}
                                        visible={formVisible}
                                        handleClose={(v) => setFormVisible(v)}
                                        lineError={lineError}
                                        form={lineForm}
                                        showNameDesc={showNameDesc}
                                        orderDetails={orderDetails}
                                    />
                                </Col>
                                <Col span={8} style={{ padding: "0px 0px 0px 10px", height: "calc(100% - 30px)" }}>
                                    <FormControl
                                        style={{ marginBottom: 10 }}
                                        className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                                        variant={'standard'}
                                        fullWidth>
                                        <RadioGroup
                                            row
                                            value={showNameDesc}
                                            onChange={(e) => handleDisplayChange(e.target.value)}>
                                            <FormControlLabel value="name" control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="Name" />
                                            <FormControlLabel value="description" control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="Description" />
                                        </RadioGroup>
                                    </FormControl>
                                    <div className={clsx(classes.heightFull, { [classes.disabled]: type === 'customerProducts' })} style={{ overflow: "auto", marginRight: "-10px", paddingRight: 10, paddingBottom: 5 }}>
                                        <NavLink to={'#'} onClick={() => handleGroupChange('')} className={clsx(classes.listprod, { [classes.listprodactive]: productGroupId === '' })}>All Products</NavLink>
                                        {
                                            productGroupDetails && productGroupDetails?.map((el, i) => (
                                                <NavLink to={'#'} onClick={() => handleGroupChange(el.id)} key={i} className={clsx(classes.listprod, { [classes.listprodactive]: productGroupId === el.id })}>{showNameDesc === 'name' ? el.name : (el?.description || '---')}</NavLink>
                                            ))
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                <Button
                                    key="Add"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleLineSubmit()}
                                    id={idNamingConversion('Add', 'salesBillLines', 'Button')}
                                    className={clsx(classes.modalBtn)}>
                                    Add
                                </Button>
                            </Space>
                        </div>
                    </div>
                    <div className={clsx(classes.customFormRight, { [classes.customFormRightSel]: selected.length > 0 })}>
                        <BillLineForm
                            {...props}
                            visible={visible}
                            form={lineForm}
                            error={lineError}
                            salesType={form?.serviceType === 'SERVICE BILL' ? 'Sale Return' : 'Sales'}
                            view={false}
                            unitMesurementdetails={unitMesurementdetails}
                            classes={classes}
                            handleClose={() => handleClose(false)}
                            customObject={(details, id) => customObject(details, id)}
                            changeHandlerLine={(e, name = '', relation = '') => changeHandlerLine(lineForm, e, name, relation)}
                            handleLineSubmit={(e) => handleLineSubmit(e)}
                            handleLineForm={(type, val) => handleLineForm(type, val)}
                            selected={selected}
                            units={units}
                            parameterDetails={parameterDetails}
                            showNameDesc={showNameDesc}
                            addBatch={() => addBatch(lineForm)}
                            onDeleteBatch={(data) => onDeleteBatch(lineForm, data)}
                            changeHandlerBatch={(e, name, i) => changeHandlerBatch(lineForm, e, name, i)}
                        />
                    </div>
                </div>
            }
        />
    )
}